import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom'; // Import useLocation from react-router-dom
import { HTTP } from '../../api/http-common';
import { ChevronDown, RotateCcw, Search } from 'lucide-react';
import CouponCard from '../../component/CouponCard';
import Pagination from '../../component/pagination';


const Explore = () => {
  const location = useLocation(); // Get the current location
  const queryParams = new URLSearchParams(location.search);
  const [cityList, setCityList] = useState([]);
  const [categoriesList, setCategoriesList] = useState([]);
  const [pagination, setPagination] = useState({ page: '1', limit: '10' });
  const [orderFilter, setOrderFilter] = useState('desc'); // Default to 'desc'
  const [formData, setFormData] = useState({
    city_id: "",
    category_id: "",
  });
  const [activeCategory, setActiveCategory] = useState(1);
  const [filteredCoupons, setFilteredCoupons] = useState([]);
  const [total, setTotal] = useState(0);
  const [filterType, setFilterType] = useState("all");
  const [search, setSearch] = useState({ category_id: null });
  const [currentPage, setCurrentPage] = useState(1);
  const access_token = localStorage.getItem('access_token');
  const [totalFilteredCouponsCount, setTotalFilteredCouponsCount] = useState(0);

  const fetchCoupons = async () => {
    let config = {
      headers: { 'Content-Type': 'application/json', 'token': access_token },
    }
    let fields = {
      filters: {
        category_id: formData.category_id,
        city_id: formData.city_id
      },
      pagination: pagination,
      sorting: { field: 'id', type: 'desc' },
    };
    HTTP.post('coupon/customer/list', fields, config)
      .then((response) => {
        const data = response.data;
        if (response.status === 200) {
          setFilteredCoupons(data.contents);
          setTotal(data.total_count);
        }
        if (response.status === 204) {
          // setAaMasters([])
        }
      })
      .catch((error) => {
        // setError(error)
        // setRerenderFlag(true);
      })
      .finally(() => {
        // setIsLoading(false);
      });
  };
  const onPaginationChange = (page) => {

    window.scrollTo({
      top: 0,
      behavior: 'smooth', // This adds a smooth scrolling effect
    });

    setPagination({ ...pagination, page });
  };
  const onLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setPagination({ ...pagination, limit: newLimit, page: 1 });
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // Adds a smooth scrolling effect
    });
    
    fetchCoupons();
    fetchCities();
    loadCategories();
    loadTotalCouponCount()
  }, [filterType, currentPage, pagination, formData]);


  // Function to get query parameters
  const getQueryParams = () => {
    const params = new URLSearchParams(location.search);
    const city_id = params.get('city_id');
    const category_id = params.get('category_id');
    return { city_id, category_id };
  };


  // Fetch cities
  const fetchCities = async () => {
    try {

      const config = {
        headers: { "Content-Type": "application/json", token: access_token },
      };
      const params = {
        category_id: formData.category_id
      };

      const response = await HTTP.post('vendors_address/city', params);

      if (response.status === 200) {
        setCityList(response.data); // Assuming response.data contains the list of cities
      }
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  // Fetch categories
  const loadCategories = async () => {
    try {
      let fields = {
        filters: {
          city_id: formData.city_id
        },
        pagination: { page: '1', limit: '100' },
        sorting: { field: 'name', type: 'asc' },
      };
      const response = await HTTP.post('/business_cate/list/all', fields);
      if (response.status === 200) {
        setCategoriesList(response.data.contents);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  const loadTotalCouponCount = async () => {
    try {
      const params = new URLSearchParams(location.search);
      let fields = {
        city_id: formData.city_id,
        category_id: formData.category_id
      };
      // console.log(fields)
      const response = await HTTP.post("/vendors_address/total_coupon_count", fields);
      // console.log(response)
      if (response.status === 200) {
        setTotalFilteredCouponsCount(response.data.total);
      }
    } catch (error) {
      console.error("Error fetching total count:", error);
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === 'order-sorting') {
      setOrderFilter(value); // Update orderFilter when order by is changed
    }
  };

  // UseEffect to handle query parameters and fetch data
  useEffect(() => {
    const { city_id, category_id } = getQueryParams();

    // If there are query parameters, set them in formData
    if (city_id || category_id) {
      setFormData((prev) => ({
        ...prev,
        city_id: city_id || null,
        category_id: category_id || null
      }));
    }

    fetchCities();
    loadCategories();
    loadTotalCouponCount();
  }, []); // Add dependencies for re-fetching

  return (
    <div className="Explore-main">
        <div className="py-3.5 call-wrapper "> 
          <div className="container mx-auto">
<div className="items-center justify-center flex">

          <div className="">
          <p className='px-4'>
          Get All of the Deals Below by Becoming a Family Fun Club Member! 
            
            </p>
          </div>
          <div className="">
            <Link to='/member/register' className='custom-theme-link-button bg-white-important px-3 py-1.5 rounded-lg shadow-md' >JOIN THE CLUB !</Link>
          </div>
</div>

          </div>
          
        </div>
      <div className="flex ">
        {/* Sidebar A */}
        <div className="w-1/5 bg-white shadow-md pt-4 mr-0.5 ">
          <h2 className="text-[28px] font-semibold pl-4 pb-4  relative z-10 border-b"> Filters</h2>
          <div className="p-4">

            <div className="custom-explore-height overflow-scroll px-2">
              <div className="mb-4 drop-down-icon">
                <label className="sidebar-input-label" htmlFor="category_id"> Category</label>

                <select
                  name="category_id"
                  value={formData.category_id}
                  onChange={handleChange}
                  className="custom-dropdown peer w-full focus:outline-none focus:border focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                >
                  <option value="">All</option>
                  {Array.isArray(categoriesList) && categoriesList.length > 0
                    ? categoriesList.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.name} ({category.total_coupon_count})
                      </option>
                    ))
                    : <option value="">No categories available</option>}
                </select>
                <span className='filter-drop-down-icon'>
                  <ChevronDown />
                </span>
              </div>

              <div className="mb-4 drop-down-icon">
                <label className="sidebar-input-label" htmlFor="city_id">City </label>

                <select
                  name="city_id"
                  value={formData.city_id}
                  onChange={handleChange}
                  className="custom-dropdown peer w-full focus:outline-none focus:border focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                >
                  <option value="">All</option>
                  {Array.isArray(cityList) && cityList.length > 0
                    ? cityList.map((city) => (
                      <option key={city.id} value={city.id}>
                        {city.name} ({city.total_coupon_count})
                      </option>
                    ))
                    : <option value="">No cities available</option>}
                </select>
                <span className='filter-drop-down-icon'>
                  <ChevronDown />
                </span>
              </div>

              <div className="mb-4 drop-down-icon">
                <label className="sidebar-input-label" htmlFor="order-sorting"> Order by</label>

                <select
                  name="order-sorting"
                  value={orderFilter}
                  onChange={handleChange}
                  className="custom-dropdown peer w-full focus:outline-none focus:border focus:border-gray-400 placeholder:text-gray-400 peer h-10 px-0 bg-transparent border border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400"
                >
                  <option value="asc">Ascending</option>
                  <option value="desc">Descending</option>
                </select>
                <span className='filter-drop-down-icon'>
                  <ChevronDown />
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w-[80%] flex flex-col justify-between bg- py-4 pt-0 mr-0.5">
          <div className="">
            <h2 className="text-[28px] bg-white font-semibold pl-4 py-4  relative z-10 shadow-[1px_1px_1px_#d5d5d5]">Available Deals <span className='theme-color'> ({totalFilteredCouponsCount}) </span> </h2>
            {Array.isArray(filteredCoupons) && filteredCoupons.length > 0 ? (
              <>
                <div className="!bg-[#f4f4f4] pb-6 px-4 pt-8  grid grid-cols-1 xl:grid-cols-2 place-items-center gap-y-10 gap-x-5  max-h-[66dvh] overflow-y-auto scrollbar-hide custom-theme-scroll    mb-5 bg-[#fefefe] custom-lightest-border">
                  {filteredCoupons.map((coupon, index) => (
                    <CouponCard key={coupon.id} coupon={coupon} />
                  ))}
                </div>

              </>
            ) : (
              <div className='flexbox justify-center h-[60dvh] theme-color font-semibold'>Deals not found</div>
            )}

          </div>
          <div className="px-4">

            <Pagination total={total} pagination={pagination} handlePageChange={onPaginationChange} handleLimitChange={onLimitChange} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Explore;
